﻿import $ from "jquery";
import require from "require";
import FiconBase from "./FiconBase";
import ElementQueries from "ElementQueries";

export default class FiconHover extends FiconBase {
	constructor() {
		super(...arguments);

		const _ = this;
		_.open = _.options.invokeType === "click" ? _.openClick : _.openHover;
	}

	static init(options) {
		super.init(options);

		require("qtip");

		const $document = $(document),
			$container = options.$container;

		$container
			.addClass(options.templateClass)
			.appendTo(document.body);

		$document
			.off("ccsBreakpointFired.ficon")
			.on("ccsBreakpointFired.ficon", ".qtip", function (e) {
				$(this).qtip("reposition", e);
			})
			.on("keydown", ".ccs-tooltip-ficon", function (e) {
				if (e.keyCode === 27) {
					$(this).qtip("hide", e);
				}
			});

		options.autoScroll &= options.direction === "top" || options.direction === "bottom";

		if (!options.autoScroll) {
			return;
		}

		let focusTimer;

		$document
			.off("ccsFicon.focus")
			.on("ccsFicon.focus", function (e) {
				clearTimeout(focusTimer);

				if (e.action === "close") {
					const $target = e.api.$icon;

					const bound = $target[0].getBoundingClientRect();
					if (bound.top < 0 || bound.bottom > window.innerHeight) {
						return;
					}

					focusTimer = setTimeout(() => $target.focus(), 120);
				}
			});
	}

	create(event) {
		super.create(event);

		const $document = $(document),
			_ = this,
			$container = _.$container,
			$section = _.$section,
			$icon = _.$icon,
			options = _.options,
			lightboxLoadEvent = "beforeLoad.ccs-fb",
			lightboxLoadEventNs = lightboxLoadEvent + ".ficon";

		if (options.invokeType === "hover") {
			$icon.removeAttr("title");
		}

		_.config = {
			overwrite: false,
			suppress: false,
			content: {
				text: $section,
				title: $("<h2>").html($section.data("title")),
				button: options.closeText
			},
			show: {
				event: false,
				solo: true,
				ready: true
			},
			hide: {
				fixed: true,
				leave: false,
				delay: 0,
				event: "unfocus"
			},
			style: {
				classes: "qtip-light qtip-shadow ccs-tooltip-ficon",
				tip: {
					width: 10,
					height: 10,
					border: 2
				}
			},
			position: {
				container: $container,
				viewport: $(window)
			},
			events: {
				render(event, api) {
					_.qtip = api;

					_.setPosition(options.direction);

					if (options.direction === "top") {
						_.fixPositionTop();
					}
				},
				visible(event, api) {
					if (event.originalEvent.type !== lightboxLoadEvent) {
						_.triggerEvent("open");
						_.autoScroll();
					} else {
						event.originalEvent.target.focus();
					}

					ElementQueries.init(`#${$section[0].id}`, options.breakpoints);

					$document
						.off(lightboxLoadEventNs)
						.one(lightboxLoadEventNs, (e) => {
							_.close(e);

							$document.one("afterClose.ccs-fb.ficon", () => {
								if (!$.fancybox.isActive) {
									_.open(e);
								}
							});
						});
				},
				hidden(event, api) {
					ElementQueries.detach($section[0]);
					$.ccsVideoPlayer.stopAllVideos();

					if (event.originalEvent.type !== lightboxLoadEvent) {
						$document.off(lightboxLoadEventNs);
						_.triggerEvent("close");
					}
				}
			}
		};
	}

	openClick(event) {
		this.qtip
			? this.qtip.show(event)
			: this.$icon.qtip(this.config, event);
	}

	openHover(event) {
		const timer = setTimeout(() => this.openClick(event), 80);
		this.$icon.one("mouseleave", () => clearTimeout(timer));
	}

	close(event) {
		this.qtip && this.qtip.hide(event);
	}

	update(event) {
		this.qtip && this.qtip.reposition(event);
	}

	setPosition(dir) {
		const p = function () {
			switch (dir) {
				case "left":
					return {
						my: "center right",
						at: "center left",
						method: "shift"
					};

				case "right":
					return {
						my: "center left",
						at: "center right",
						method: "shift"
					};

				case "bottom":
					return {
						my: "top center",
						at: "bottom center",
						method: "shift flip"
					};

				default:
					return {
						my: "bottom center",
						at: "top center",
						method: "shift flip"
					};
			}
		}();

		this.qtip.set({
			"position.my": p.my,
			"position.at": p.at,
			"position.adjust.method": p.method
		});
	}

	autoScroll() {
		if (!this.options.autoScroll) {
			return;
		}

		const $window = $(window);
		const $root = $(/WebKit/i.test(navigator.userAgent) ? "body" : "html");

		clearTimeout(FiconHover.scrollTimer);

		FiconHover.scrollTimer = setTimeout(() => {

			const $tooltip = this.qtip.tooltip;
			const bound = $tooltip[0].getBoundingClientRect();

			const wHeight = $window.height();

			const focus = () => this.$section.focus();

			if (bound.bottom > wHeight) {
				$root.animate({ scrollTop: $window.scrollTop() - wHeight + bound.bottom + 5 }, 500, "swing", focus);
				return;
			}

			if (bound.top < 0) {
				$root.animate({ scrollTop: $window.scrollTop() + bound.top - 5 }, 500, "swing", focus);
				return;
			}

			focus();
		}, 100);
	}

	fixPositionTop() {
		const _ = this,
			$icon = _.$icon,
			$window = $(window),
			$tooltip = _.qtip.tooltip;

		_.currentDir = "top";

		const reposition = function (e) {

			const targetDir = $icon.offset().top - $window.scrollTop() > 0 ? "top" : "bottom";

			if (_.currentDir !== targetDir) {
				_.setPosition(targetDir);
				_.currentDir = targetDir;

				setTimeout(() => _.update(e), 0);
			}

			$tooltip.one("tooltipmove", reposition);
		}

		$tooltip.one("tooltipmove", reposition);
	}

	adjustMedia($section) {
		super.adjustMedia($section);

		$section.one("ccsGalleryLoad", () => this.autoScroll());
	}

	adjustSpin($section) {
		$section.one("ccsSpinLoad", () => this.autoScroll());
	}

	adjustHotspots($section) {
		$section.one("ccsFicon", function (e) {
			const $tooltip = e.api.qtip.tooltip;

			$tooltip
				.on("tooltiphide", (event) => {
					if ($(event.originalEvent.target).closest(".ccs-hotspots-tooltip").length) {
						event.preventDefault();
					}
				})
				.on("tooltiphidden", () => {
					$tooltip.find(".ccs-hotspots-point").qtip("hide");
				});
		});
	}

	adjustXboxInteractiveStudio($section) {
		$section.one("ccsFicon", () => {
			$section.on("ccsFicon", e => {

				if (e.action === "open") {
					const event = new Event("resize");
					window.dispatchEvent(event);
				}

				if (e.action === "close") {
					const $iframeXboxInteractiveStudio = $section.find(".ccs-logo-xbox-interactive-studio iframe");
					const srcValue = $iframeXboxInteractiveStudio.attr("src");
					$iframeXboxInteractiveStudio.attr("src", "");
					$iframeXboxInteractiveStudio.attr("src", srcValue);
				}
			});
		});
	}
}
